// styles
import styles from './filter.module.scss';

// components
import { Dropdown } from 'components/Dropdown/Dropdown';

// utils
import { isEmpty } from 'utils/is-empty';
import { useTranslationFunction } from 'utils/hooks/use-translations';
import { useTracking as useGA4Tracking } from 'utils/tracking/track';

interface ModelFilterProps {
  label: string;
  setFilterModel: (filterModel: string[]) => void;
  filterModel: string[];
  models: string[] | null;
}

export function ModelFilter({
  label,
  setFilterModel,
  filterModel,
  models,
}: Readonly<ModelFilterProps>) {
  const translate = useTranslationFunction();
  const { trackEvent } = useGA4Tracking();

  if (isEmpty(models)) return null;

  // Add or delete filter value from state
  const handleDropdownClick = (item) => {
    if (item?.id && filterModel.includes(item?.id)) {
      // delete current filter value
      const newFilter = filterModel.filter((option) => option !== item?.id);
      setFilterModel(newFilter);
      if (newFilter.length > 0) {
        trackEvent({
          event: 'locator_interaction',
          click_intent: 'locator filter - product',
          content_type: 'locator-hotel',
          search_term: newFilter.join(', '),
          value: '',
        });
      }
    } else if (item?.id) {
      // add new filter value
      const newFilter = filterModel.concat(item?.id);
      setFilterModel(newFilter);
      trackEvent({
        event: 'locator_interaction',
        click_intent: 'locator filter - product',
        content_type: 'locator-hotel',
        search_term: newFilter.join(', '),
        value: '',
      });
    } else {
      // reset all filters when all filter is clicked
      setFilterModel([]);
    }
  };

  const items = models
    .filter((x) => x)
    .sort((a, b) => a?.localeCompare(b))
    .map((value) => {
      return { id: value, name: value };
    });

  return (
    <>
      <div className={styles.modelFilterWrapper}>
        <div className="form-item">
          <Dropdown
            placeholder={label}
            label={label}
            items={items}
            handleDropdownClick={handleDropdownClick}
            allLabel={translate('web20_hotel_locator_filter_all')}
            useCheckboxes
            showAll
          />
        </div>
      </div>
      <div className={styles.placeHolder}></div>
    </>
  );
}
